import { render, staticRenderFns } from "./CoozzyFiltersIcon.vue?vue&type=template&id=3df4f1f3&scoped=true"
import script from "./CoozzyFiltersIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyFiltersIcon.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFiltersIcon.vue?vue&type=style&index=0&id=3df4f1f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df4f1f3",
  null
  
)

export default component.exports